// extracted by mini-css-extract-plugin
module.exports = {"mergeIntoRoot":"MergeInto_mergeIntoRoot__3kp2v","mergeIntoInfo":"MergeInto_mergeIntoInfo__isSTb","mergeIntoList":"MergeInto_mergeIntoList__QY2Cn"};